<script setup name="TvbVideoDetailDescription">
import { inject, computed, ref } from 'vue'
import ArticleContent from '@/views/Article/Detail/components/ArticleContent/index.vue'

const currentVideo = inject('currentVideo')
const playerWidth = inject('playerWidth', '100%')
const description = computed(() => currentVideo.value.description || '')
const size = inject('size')
const isOpen = ref(true)
const descriptionContentRef = ref(null)
const tags = computed(() => currentVideo.value.tags || [])
// const showOpen = computed(() => playerWidth?.value ? (descriptionContentRef?.value?.clientHeight + 48) > 280 : false)

// const handleOpenClick = () => {
//     isOpen.value = !isOpen.value
// }
</script>

<template>
  <div
    class="tvb-video-detail_description"
    :style="{ width: playerWidth, maxHeight: isOpen ? 'none' : '280px' }"
    :class="[size]"
  >
    <!-- <article-content
            ref="richRef"
            :content="contents"
            :id="articleId"
            :img="articleVideo.video_url ? '' : info.image_info?.large"
            :thumbnail="info.image_info?.small"
            @viewerShown="onViewerShown"
            @viewerChange="onViewerChange"
          ></article-content> -->
    <article-content
      id="currentVideo.id"
      :img="currentVideo.image_info.small"
      :thumbnail="currentVideo.image_info?.small"
      class="tvb-video-detail_description-content"
      :content="[{ type: 1, rich_text: { html: description }, image: null }]"
      ref="descriptionContentRef"
    ></article-content>
    <!-- <div class="tvb-video-detail_description-expand" v-if="!isOpen && showOpen">
            <button class="tvb-video-detail_description-expand-btn" @click="handleOpenClick">展開全文<tvb-svg-icon
                    class="tvb-video-detail_description-btn-icon" name="arrow_bottom" /></button>
        </div>
        <button v-else-if="showOpen" class="tvb-video-detail_description-collapse-btn"
            @click="handleOpenClick">收起<tvb-svg-icon class="tvb-video-detail_description-btn-icon"
                name="arrow_top" /></button> -->

    <div class="tvb-video-detail_info-tags" :style="{ width: playerWidth }" v-if="tags.length">
      <router-link
        class="tvb-video-detail_info-tag"
        v-for="tag in tags"
        :key="tag.name"
        :to="`/search?tag=${tag.id}&tag_name=${tag.name}`"
        ># {{ tag.name }}</router-link
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tvb-video-detail_description {
  width: 1280px;
  padding: 24px;
  border-radius: 24px;
  background: #f5f6f7;
  margin: 16px 0;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  transition: height 0.15s ease-in;
  max-height: 280px;
  color: #333333;

  @media (max-width: 1143px) {
    width: 100% !important;
  }

  @media (max-width: 1440px) {
    &.xl {
      margin: 12px 0 16px;
    }
  }

  &.xl {
    padding: 24px;
  }

  &.m,
  &.s,
  &.xs {
    padding: 16px;
    // 描述容器圆角：16px → 20px（与文章详情同步）
    border-radius: 20px;

    .tvb-video-detail_description-content {
      :deep(*) {
        font-size: 16px;
        // 正文行高对齐工单要求：28px → 24px
        line-height: 24px;
      }
    }
    .tvb-video-detail_info-tags {
      gap: 10px;
      margin-top: 20px;

      .tvb-video-detail_info-tag {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.3px;
      }
    }
  }

  .tvb-video-detail_description-content {
    height: fit-content;

    :deep(img) {
      border-radius: 24px;
    }
  }

  .tvb-video-detail_description-expand {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    height: 160px;
    padding-bottom: 16px;
    border-radius: 0 0 16px 16px;
    background: linear-gradient(
      180deg,
      rgba(245, 246, 247, 0) 0%,
      rgba(245, 246, 247, 0.3) 30%,
      rgba(245, 246, 247, 0.8) 60%,
      #f5f6f7 100%
    );
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    .tvb-video-detail_description-expand-btn {
      width: fit-content;
      display: flex;
      padding: 6px 12px 6px 16px;
      justify-content: center;
      align-items: center;
      border-radius: 12px;
      background: rgba(0, 0, 0, 0.04);
      backdrop-filter: blur(25px);
      color: #444;
      font-size: 15px;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0.3px;
      border: 0;
      outline: 0;
      cursor: pointer;
    }
  }

  .tvb-video-detail_description-collapse-btn {
    margin-top: 32px;
    display: flex;
    padding: 6px 12px 6px 16px;
    align-items: center;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.04);
    color: #444;
    font-size: 15px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.3px;
    border: 0;
    outline: 0;
    cursor: pointer;
  }

  .tvb-video-detail_info-tags {
    display: flex;
    gap: 12px;
    margin-top: 24px;
    flex-wrap: wrap;

    .tvb-video-detail_info-tag {
      display: flex;
      padding: 8px 16px;
      align-items: center;
      border-radius: 999px;
      // 标签边框色对齐设计稿：#d9dddf → rgba(163, 178, 188, 0.35)
      border: 1px solid rgba(163, 178, 188, 0.35);
      color: #444;
      font-size: 15px;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0.3px;
      &:hover {
        text-decoration: none;
        // hover 可见反馈：保持白底并加深边框（原 #fff 背景在 #f5f6f7 容器内视觉不明显，且不位移文字）
        background-color: #fff;
        border-color: rgba(163, 178, 188, 0.6);
      }
    }
  }
}
</style>
